import { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { SectionCard } from "../AppShell";
import { Input } from "../ui/input";
import { AdjustmentGrid } from "./AdjustmentGrid";
import { AdjustmentDialog } from "./AdjustmentDialog";
import { AdjustmentRequests } from "./AdjustmentRequests";
import { prevMonth } from "./adjustUtils";

const LEGEND = "P Present · ½ Half day · A Absent · WO Weekly off · H Holiday · · No punch · blue outline = adjusted · amber = awaiting approval";

function StatusNote({ data }) {
  if (data.locked) return <div className="mb-3 text-xs rounded-md border border-sky-200 bg-sky-50 text-sky-800 px-3 py-2" data-testid="adj-locked-banner">Payroll for this month is {data.run_status}. Approved changes are paid or recovered as arrears in the next payroll.</div>;
  if (data.pending_count) return <div className="mb-3 text-xs rounded-md border border-amber-200 bg-amber-50 text-amber-800 px-3 py-2" data-testid="adj-pending-banner">{data.pending_count} change(s) awaiting a second admin's approval — payroll for this month cannot be finalised until they are approved or rejected.</div>;
  return null;
}

export function AttendanceAdjustments() {
  const [month, setMonth] = useState(prevMonth);
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const [pick, setPick] = useState(null);
  const [key, setKey] = useState(0);
  const load = useCallback(() => {
    let live = true;
    api.get(`/attendance-adjustments/grid?month=${month}`).then(r => { if (live && r.data.month === month) setData(r.data); });
    return () => { live = false; };
  }, [month]);
  useEffect(() => { setData(null); return load(); }, [load]);
  const refresh = () => { load(); setKey(k => k + 1); };

  return (
    <div className="space-y-5" data-testid="adj-panel">
      <SectionCard title="HR attendance adjustments" subtitle={LEGEND} testid="adj-grid-card"
        action={<div className="flex gap-2">
          <Input placeholder="Search name or code" className="h-9 w-48" value={q} onChange={e => setQ(e.target.value)} data-testid="adj-search"/>
          <Input type="month" className="h-9 w-40" value={month} onChange={e => e.target.value && setMonth(e.target.value)} data-testid="adj-month"/>
        </div>}>
        {!data ? <div className="text-sm text-zinc-500">Loading…</div> : (
          <>
            <StatusNote data={data}/>
            <AdjustmentGrid data={data} q={q} onPick={setPick}/>
          </>
        )}
      </SectionCard>
      <AdjustmentRequests month={month} refreshKey={key} onChange={load}/>
      <AdjustmentDialog pick={pick} locked={data?.locked} onClose={() => setPick(null)} onSaved={refresh}/>
    </div>
  );
}
